import styled from "styled-components";
import { Button } from "../../../design-system/components/primitives/Button/Button";
import { controlSize } from "../../../design-system/tokens/controlSizes";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  flex-shrink: 0;
`;

const headerActionButtonStyles = `
  && {
    ${typographyMixin("body", 2)}
    height: ${controlSize.field.md};
    min-height: ${controlSize.field.md};
    box-sizing: border-box;
    padding: 0 ${spacing[4]};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const DarkPrimaryActionButton = styled(Button)`
  ${headerActionButtonStyles}
  && {
    color: ${rawColors.text.white};
    background: ${rawColors.primary[900]};
    border-color: ${rawColors.primary[900]};

    &:hover:not(:disabled) {
      background: ${rawColors.primary[900]};
      border-color: ${rawColors.primary[900]};
      opacity: 0.92;
    }

    &:disabled {
      opacity: 0.6;
    }
  }
`;
